import Constants from 'expo-constants';

/**
 * Which deployment this build talks to. Set at build time via APP_VARIANT
 * (see app.config.ts): `staging` for the staging web/TestFlight builds,
 * `production` otherwise. See agents/plans/staging-environment.md.
 */
export type AppVariant = 'production' | 'staging';

const extra = Constants.expoConfig?.extra ?? {};

export const APP_VARIANT: AppVariant = extra.APP_VARIANT === 'staging' ? 'staging' : 'production';

export const IS_STAGING = APP_VARIANT === 'staging';

/** Native URL scheme (`cached` / `cached-staging`), used for auth redirects and deep links. */
export const APP_SCHEME: string =
  (typeof Constants.expoConfig?.scheme === 'string' && Constants.expoConfig.scheme) ||
  (IS_STAGING ? 'cached-staging' : 'cached');

/** Public web origin for share links, e.g. https://discovercache.com. */
export const WEB_BASE_URL: string = (
  extra.EXPO_PUBLIC_WEB_BASE_URL || 'https://discovercache.com'
).replace(/\/+$/, '');
